import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { OrganizationStratalotTodoEntityState } from '@_model/interfaces/organization-stratalot-todo.model';

export interface OrganizationStratalotTodoState extends EntityState<OrganizationStratalotTodoEntityState> {
  isLoaded: boolean;
  isLoading: boolean;
  actives: number[];
}

export const adapter: EntityAdapter<OrganizationStratalotTodoEntityState> =
  createEntityAdapter<OrganizationStratalotTodoEntityState>({
    selectId: o => o.idOrganizationStratalotTodo
  });
export const initialState: OrganizationStratalotTodoState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const organizationStratalotTodoFeatureKey = 'organizationStratalotTodo';
